import { FileClient, RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B090010FindRequest = Partial<{
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  shohinKana: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  sokoCd: string;
  sokoshubetsuKbn: string;
  shohinshubetsuKbn: string;
  gokeisuHyoji: string;
  nyukayoteisuHyoji: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B090010FindResponse = {
  shohinCd: string;
  shohinNmr: string;
  sokoCd: string;
  sokoNm: string;
  zaikosu: string;
  hikiatesu: string;
  kanosu: string;
  nyukayoteisu: string;
  janCd: string;
  sokoshubetsuKbn: string;
  zaikosuGokei: string;
  hikiatesuGokei: string;
  hikiatekanosuGokei: string;
  nyukayoteisuGokei: string;
};

//検索処理
export const B090010Find = (props: B090010FindRequest) => {
  return RestClient.get<PageableResponse<B090010FindResponse>>("b090010/find", {
    params: props,
  });
};

export type B090010ExcelRequest = Partial<{
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  shohinKana: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  sokoCd: string;
  sokoshubetsuKbn: string;
  shohinshubetsuKbn: string;
  gokeisuHyoji: string;
  nyukayoteisuHyoji: string;
  sort: string[];
}>;

//Excel出力処理
export const B090010GetExcel = (props: B090010ExcelRequest) => {
  return FileClient.get("b090010/get/excel", {
    params: props,
  });
};
